<script setup lang="ts">
import { dateZhCN, zhCN } from 'naive-ui'
import { adminThemeOverrides } from '~/utils/adminTheme'
</script>

<template>
  <n-config-provider :locale="zhCN" :date-locale="dateZhCN" :theme-overrides="adminThemeOverrides">
    <n-loading-bar-provider>
      <n-message-provider>
        <n-dialog-provider>
          <AppAdminLoadingBar />
          <slot />
        </n-dialog-provider>
      </n-message-provider>
    </n-loading-bar-provider>
  </n-config-provider>
</template>
